import React from "react";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import tryLiveIcon from "../../Asset/try live.svg";
import { FiDownload } from "react-icons/fi";

const SideCTA = () => {
  return (
    <div className=" flex md:flex-col flex-row items-center md:gap-3 gap-[6px] bg-transparent md:p-0 md:shadow-none md:rounded-none md:mb-16 mb-12">
      {/* Mobile: show only the download icon button */}
      <NavLink
        to="/download"
        aria-label="Download"
        className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-b from-[#3AB1F6] to-[#407BFF] shadow-[0px_4px_17.5px_0px_#0000001C]"
      >
        <FiDownload className="size-5 text-white" />
      </NavLink>

      {/* Desktop: Try Live + Download buttons */}
      <NavLink
        to="/demo"
        className={`bg-gradient-to-r font-inter md:shadow-md from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out text-white leading-none  md:text-sm text-sm w-32  py-2  md:flex hidden items-center justify-center gap-2 rounded-full font-medium `}
      >
        <ReactSVG
          src={tryLiveIcon}
          beforeInjection={(svg) => {
            svg.setAttribute("class", "lg:w-4 w-4 lg:h-4 h-4");
          }}
        />
        <span>Try Live</span>
      </NavLink>
      <NavLink
        to="/download"
        className={` font-inter md:shadow-md bg-white hover:bg-[#3AB1F629]  transition-all duration-300 ease-in-out text-[#364153] leading-none  md:text-sm text-sm w-32  py-2  md:flex hidden items-center justify-center gap-2 rounded-full font-medium `}
      >
        <FiDownload className=" size-4" />
        <span>Download</span>
      </NavLink>
    </div>
  );
};

export default SideCTA;
